import { render } from "./headingComponent.vue?vue&type=template&id=128cce51&scoped=true"
import script from "./headingComponent.vue?vue&type=script&lang=js"
export * from "./headingComponent.vue?vue&type=script&lang=js"

import "./headingComponent.vue?vue&type=style&index=0&id=128cce51&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128cce51"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/headingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "128cce51"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('128cce51', __exports__)) {
    api.reload('128cce51', __exports__)
  }
  
  module.hot.accept("./headingComponent.vue?vue&type=template&id=128cce51&scoped=true", () => {
    api.rerender('128cce51', render)
  })

}


export default __exports__